<template>
  <v-row>
    <v-col cols="12" class="header-with-select-box">
      <h3 class="text-primary weight-600">Upload Documents</h3>
    </v-col>
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <v-row v-for="(supportingDoc, index) in supplementalDocs" :key="index" class="mb-4 pa-2 border rounded-16">
            <v-col cols="12" sm="7" md="8" class="d-flex align-center">
              <v-text-field
                :id="`supporting-doc-label-${index}`"
                v-model="supportingDoc.label"
                placeholder="Add label to your upload"
                class="lh--force-white-background"
                hide-details />
            </v-col>
            <v-col cols="12" sm="5" md="4" class="d-flex align-center" style="min-width: 0">
              <div v-if="supportingDoc.links.length" class="w-100">
                <div v-for="link in supportingDoc.links" :key="link">
                  <v-btn :href="link" target="_blank" variant="text" color="primary" prepend-icon="mdi-download">
                    Download
                  </v-btn>
                </div>
              </div>
              <div v-else-if="props.isEditable" class="w-100" style="min-width: 0">
                <UploadFileComponent
                  :download-destination="props.downloadDestination"
                  :download-destination-index="index"
                  @download-link="addFreeFormSupplementalDocsDownloadLink" />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn color="primary" variant="outlined" prepend-icon="mdi-plus" @click="addSupportingDocumentUpload">
            Add Supplemental Document
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script setup>
import { ref } from "vue";
import UploadFileComponent from "@/components/UploadFileComponent";

const emit = defineEmits(["add-free-form-supplemental-docs"]);

const props = defineProps({
  supplementalDocs: {
    type: Array,
    required: true,
  },
  downloadDestination: {
    type: String,
    default() {
      return "";
    },
  },
  isEditable: {
    type: Boolean,
    default() {
      return false;
    },
  },
});

const supplementalDocs = ref(props.supplementalDocs);

function addSupportingDocumentUpload() {
  supplementalDocs.value.push({
    label: null,
    links: [],
  });
}

const addFreeFormSupplementalDocsDownloadLink = (downloadLinkInfo) => {
  emit("add-free-form-supplemental-docs", downloadLinkInfo);
};
</script>

<style lang="scss" scoped>
@import "../styles/main.scss";
</style>
